import React from 'react';
import { FadeIn } from './FadeIn';
import { MicIcon, UsersIcon, StarIcon, TrendingUpIcon } from 'lucide-react';
export function Transformation() {
  const steps = [{
    icon: <MicIcon className="w-6 h-6 text-pump-dark" data-id="element-236" />,
    title: 'Antes de que empiece la música',
    text: 'Entrás a la sala con una presencia que ya dice algo. Tu postura, tu mirada, la forma en que revisás la barra antes de empezar. Los alumnos lo sienten antes de que digas una sola palabra. Ese silencio previo ya es parte de la experiencia.'
  }, {
    icon: <UsersIcon className="w-6 h-6 text-pump-dark" data-id="element-237" />,
    title: 'Durante el track más duro',
    text: 'Tus alumnos están en el valle del dolor. Lunges, tercera serie, peso máximo. Y en ese momento exacto, vos decís las palabras correctas en el tono correcto. No los motivás a gritos. Los llevás. Y ellos no saben cómo, pero encuentran tres repeticiones más que juraban que no tenían.'
  }, {
    icon: <StarIcon className="w-6 h-6 text-pump-dark" data-id="element-238" />,
    title: 'Los 5 minutos después de la clase',
    text: 'No corrés al vestuario. Te quedás. Escuchás. Sonreís. Hacés una pregunta que demuestra que los recordás. Ese momento de 5 minutos vale más para la fidelización que cualquier técnica de marketing. Es donde se construye la lealtad real.'
  }, {
    icon: <TrendingUpIcon className="w-6 h-6 text-pump-dark" data-id="element-239" />,
    title: 'El lunes siguiente',
    text: 'El alumno que vino por primera vez el miércoles pasado busca tu horario en la grilla. No el de BodyPump genérico. El tuyo. Porque algo pasó en esa clase que no puede explicar pero que quiere volver a sentir. Eso es lo que construye un instructor inolvidable.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-pump-surface relative overflow-hidden" data-id="element-240">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-pump-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-241" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-242">
        <FadeIn data-id="element-243">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-16 leading-tight" data-id="element-244">
            Existe una versión de tu clase
            <br className="hidden sm:block" data-id="element-245" />
            <span className="text-pump-gold" data-id="element-246">
              {' '}
              que se siente completamente diferente.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-247">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-248">
              <div className="flex flex-col sm:flex-row gap-6 items-start bg-pump-dark border border-pump-muted p-6 sm:p-8 rounded-2xl relative overflow-hidden group hover:border-pump-gold/50 transition-colors" data-id="element-249">
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-pump-muted group-hover:bg-pump-gold transition-colors" data-id="element-250" />
                <div className="bg-pump-gold w-12 h-12 rounded-full flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(245,200,66,0.3)]" data-id="element-251">
                  {step.icon}
                </div>
                <div data-id="element-252">
                  <h3 className="text-xl font-display font-bold text-white mb-2" data-id="element-253">
                    {step.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-254">{step.text}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-255">
          <div className="text-center mt-16" data-id="element-256">
            <p className="text-2xl sm:text-3xl font-display font-bold text-white" data-id="element-257">
              Esa versión de tu clase no requiere más talento.{' '}
              <br className="hidden sm:block" data-id="element-258" />
              <span className="text-pump-gold" data-id="element-259">
                Requiere el sistema correcto.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}